import React from 'react';
import ActivityMediumBox from '../../../summaryReport/components/Box/ActivityMediumBox';
import ChipPlace from '../../../../components/Chip/ChipPlace';
import StackedBarChart from '../../../summaryReport/components/Chart/StackedBarChart';
// import NoDataBox from '../../../summaryReport/components/Box/NoDataBox';
import { dayDate, yearDate, tenYearsDate } from '../../../../utils/summaryGraph';
import * as ActionColors from '../../../../themes/summaryReportColor';
import * as Icons from '@material-ui/icons';
// import ViewSubTypeForYearRadioBar from '../Navbar/ViewSubTypeForYearRadioBar';

import * as moment from 'moment';

const TotalFixedEmergencyDeviceLegend = (props) => {
  const { t, totalSummary } = props;
  return (
    <div>
      <div className='flex w-full my-auto'>
        <div className='block w-3/4'>
          <div className='relative mb-5 w-max '>
            <div
              className={`flex items-center h-8 px-4 py-1 text-lg font-normal text-black rounded-3xl max-w-225px overflow-hidden overflow-ellipsis whitespace-nowrap border border-black`}
            >
              {t('total')}
            </div>
          </div>
        </div>
        <div className='block w-3/12'>
          <div className='text-xl font-medium text-right text-summary-header '>{totalSummary}</div>
        </div>
      </div>

      {props.data.map((val, i) => (
        <div className='flex w-full my-auto' key={i}>
          <div className='block w-3/4'>
            <ChipPlace label={val.name} color={props.color[val.name]} />
          </div>
          <div className='block w-3/12'>
            <div className='text-xl font-medium text-right text-summary-header '>{val.value}</div>
            <div className='text-xs font-normal text-right text-gray-500'>
              <span className='text-2xl'>
                <Icons.BarChartRounded />
              </span>
              <span> {val.percent.toFixed(2) !== '0.00' ? val.percent.toFixed(2) : '≈ 0'}%</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

const FixedEmergencyDevice = (props) => {
  const { t } = props;
  const margin = {
    top: 20, //20,
    right: 20, //20,
    bottom: 40, //40,
    left: 60, //60
  };
  const width = 740 - margin.left - margin.right;
  const height = 515 - margin.top - margin.bottom;

  const filteredDeviceTotal = fixedEmergencyDeviceLegendTotal(props.data);

  const colors = nameColors(filteredDeviceTotal);

  const deviceGraph = deviceGraphData(props.date, props.data, props.viewType, filteredDeviceTotal);

  return (
    <div className='flex-wrap flex-auto min-w-0 px-2 mb-16'>
      <div className='relative flex-col flex-wrap block col-span-12 mx-3 my-4 pb-9'>
        <div className='content-end block col-span-12 px-4 pt-4 text-2xl lg:flex md:flex xl:flex'>
          {props.tenantName}
          <div className='content-end px-8 mb-1 text-xs'>
            {labelDateRange(deviceGraph, props.viewType, t)}
          </div>
        </div>

        <div className='pb-5'>
          <div className='flex-wrap block xl:flex'>
            <div className='w-full p-4 pt-1 xl:w-2/3'>
              <div className='flex flex-wrap flex-grow col-span-12 my-1'></div>
              <div className='rounded-md xl:mb-5 lg:mb-5 bg-primary-gradient h-428'>
                <StackedBarChart
                  width={width}
                  height={height}
                  margin={margin}
                  color={colors}
                  rect={rectProperty(props.viewType, deviceGraph)}
                  data={deviceGraph}
                  unit={t('times')}
                  lableX={labelXAxis(t, props.viewType)}
                  viewType={props.viewType}
                />
              </div>
            </div>

            <div className='w-full xl:w-1/3 lg:mt-16 xl:mt-0 md:mt-8 sm:mt-8'>
              <div className='lg:flex xl:block'>
                <div className='mx-4 my-2 xl:mx-4 lg:mx-2 md:mx-4'>
                  <ActivityMediumBox
                    header={`${t('total')} / ${props.viewType !== '10year' ? t(props.viewType) : props.t('10_years')}`}
                  >
                    <div className='mt-2'>
                      <TotalFixedEmergencyDeviceLegend
                        data={filteredDeviceTotal}
                        color={colors}
                        t={t}
                        totalSummary={props.totalSummary}
                      />
                    </div>
                  </ActivityMediumBox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const labelDateRange = (deviceGraph, viewType, t) => {
  const dates = (deviceGraph || []).map((d) => d.refDate);
  const startDate = moment(new Date(dates[0])).format('DD/MM/YYYY');
  const endDate = moment(new Date(dates[dates.length - 1])).format('DD/MM/YYYY');
  let result = `${t('during_the_day')} ${startDate} - ${endDate}`;
  
  if (viewType === 'year') {
    const startMonth = moment(new Date(dates[0])).format('MM/YYYY');
    const endMonth = moment(new Date(dates[dates.length - 1])).format('MM/YYYY');
    result = `${t('during_the_month')} ${startMonth} - ${endMonth}`;
  } else if (viewType === '10year') {
    result = `${t('during_the_year')} ${dates[0]} - ${dates[dates.length - 1]}`;
  }

  return result;
};

const labelXAxis = (t, viewType) => {
  let result = t('days_for_graph');
  if (viewType === 'year') {
    result = t('months');
  } else if (viewType === '10year') {
    result = t('years');
  }
  return result;
};

const fixedEmergencyDeviceLegendTotal = (data) => {
  const total = {};
  data.forEach((d) => {
    if (d.alerts.length > 0) {
      d.alerts.forEach((a) => {
        if (total.hasOwnProperty(a.name)) {
          total[a.name] += +a.times;
        } else {
          total[a.name] = +a.times;
        }
      });
    }
  });

  // sum all total
  const sumTotalTime = Object.values(total).reduce((a, b) => a + b, 0);

  const allData = [];
  for (const [key, value] of Object.entries(total)) {
    allData.push({
      name: key,
      value: value || 0,
      percent: value ? (value / sumTotalTime) * 100 : 0,
    });
  }

  // sort data by value
  const result = allData.sort((a, b) => (a.value < b.value ? 1 : b.value < a.value ? -1 : 0));
  return result;
};

const rectProperty = (viewType, deviceGraph) => {
  const totalSummary = deviceGraph.map((d) => d.totalSummary).filter((d) => d);
  const maxTotalValue = Math.max(...totalSummary);

  const rectWeek = { width: 30, padding: 0.7, maxValue: maxTotalValue < 24 ? 24 : 100 };
  const rectMonth = { width: 15, padding: 0.5, maxValue: maxTotalValue < 24 ? 24 : 100 };
  const rectYear = { width: 30, padding: 0.45, maxValue: 500 };

  if (viewType === 'week') {
    return rectWeek;
  } else if (viewType === 'month') {
    return rectMonth;
  }

  return rectYear;
};

const deviceGraphData = (date, dataOrig, viewType, filteredDeviceTotal) => {
  const data = dataOrig
    .map((d) => {
      if ((d.alerts || []).filter((a) => filteredDeviceTotal.find((f) => `${f.name}` === `${a.name}`)).length > 0) {
        const tmp = { ...d };
        tmp.alerts = tmp.alerts.filter((a) => filteredDeviceTotal.find((f) => `${f.name}` === `${a.name}`));
        return tmp;
      }
      return null;
    })
    .filter((d) => d);

  const templateDate = {};
  for (const d of data || []) {
    d.alerts.forEach((a) => {
      templateDate[a.name] = { value: 0, hoverTxt: '', nameTxt: '' };
      templateDate['totalSummary'] = 0;
    });
  }

  let templateData = [];
  if (viewType === 'week') {
    const dateStart = moment(new Date(`${date}`))
      .subtract(1, 'w')
      .add(1, 'd')
      .startOf('day')
      .toDate();
    const dateEnd = moment(new Date(`${date}`))
      .endOf('day')
      .toDate();

    const dateRange = dayDate(dateStart, dateEnd, viewType);
    templateData = (dateRange || []).map((d) => {
      return { ...d, ...templateDate };
    });
  } else if (viewType === 'month') {
    const dateStart = moment(new Date(`${date}`))
      .subtract(4, 'w')
      .add(1, 'd')
      .startOf('day')
      .toDate();
    const dateEnd = moment(new Date(`${date}`))
      .endOf('day')
      .toDate();

    const dateRange = dayDate(dateStart, dateEnd, viewType);
    templateData = (dateRange || []).map((d) => {
      return { ...d, ...templateDate };
    });
  } else if (viewType === 'year') {
    const dateStart = moment(new Date(`${date}`))
      .subtract(1, 'y')
      .add(1, 'd')
      .startOf('month')
      .toDate();
    const dateEnd = moment(new Date(`${date}`))
      .startOf('month')
      .toDate();
    const formatDate = 'YYYY-MM';
    const dateRange = yearDate(dateStart, dateEnd, formatDate);
    templateData = (dateRange || []).map((d) => {
      return { ...d, ...templateDate };
    });
  } else {
    const dateStart = moment(new Date(`${date}`))
      .subtract(10, 'y')
      .add(1, 'y')
      .startOf('year')
      .toDate();
    const dateEnd = moment(new Date(`${date}`))
      .startOf('year')
      .toDate();
    const dateRange = tenYearsDate(dateStart, dateEnd);
    templateData = (dateRange || []).map((d) => {
      return { ...d, ...templateDate };
    });
  }

  (data || []).forEach((d) => {
    if (d.alerts.length > 0) {
      const refDate = moment(new Date(`${d.date}`));
      const found = templateData.find((t) => {
        return moment(t.refDate).isSame(refDate, 'day');
      });

      if (found) {
        d.alerts.forEach((a) => {
          found[a.name] = {
            value: +a.times,
            hoverTxt: `${a.times}`,
            nameTxt: a.name,
          };
          found['totalSummary'] = d.total;
        });
      }
    }
  });

  return templateData;
};

const nameColors = (data) => {
  const nameColors = {};

  (data || []).forEach((p, index) => {
    nameColors[p.name] = locationColors[index];
  });
  return nameColors;
};

const locationColors = ActionColors.COLOR_LOCATION;

export default FixedEmergencyDevice;
